module.exports = __webpack_public_path__ + "static/media/facebook-v2.280a6e12.svg";